import { render, staticRenderFns } from "./register_验证码版本.vue?vue&type=template&id=577f297e&scoped=true"
import script from "./register_验证码版本.vue?vue&type=script&lang=js"
export * from "./register_验证码版本.vue?vue&type=script&lang=js"
import style0 from "./register_验证码版本.vue?vue&type=style&index=0&id=577f297e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577f297e",
  null
  
)

export default component.exports